import classnames from 'classnames';

import { Text } from '@/core/tamagoshi/Text/Text';
import { Alert } from '@/domains/core/tamagoshi/icons/Alert';
import { colors } from '@/domains/core/tamagoshiv2/tokens/tokens';
import { Error } from '@/domains/shoppingCart/AddToCart/AddToCart.interfaces';
import { formatErrorMessage } from '@/domains/shoppingCart/AddToCart/components/utils/formatErrorMessage';

import styles from './addToCartErrorLabel.module.scss';

interface Props {
  error: Error;
  className?: string;
}

export const AddToCartErrorLabel = ({ error, className }: Props) => (
  <div className={classnames(styles.error, className)}>
    <Alert width={16} height={16} color={colors.warning.textIconPrimary} />
    <Text weight="semiBold" className={styles.text}>
      {formatErrorMessage(error)}
    </Text>
  </div>
);
